import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { isPlatformBrowser, DOCUMENT } from "@angular/common";
import { filter } from "rxjs";

declare var gtag: any;
@Injectable({
  providedIn: "root"
})
export class RouteService {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platform: Object,
    @Inject(DOCUMENT) private dom:any
  ) {}

  // setupGTMPageView() {
  //   if (isPlatformBrowser(this.platform)) {
  //       const script = document.createElement("script");
  //       const noscript = document.createElement("noscript");
  //       script.async = true;
  //       script.src =
  //       "https://www.googletagmanager.com/gtm.js?id=GTM-P64PZVB";
  //       ;
  //       (document.head as any).prepend(script);
    
  //       const ifrm = document.createElement("iframe");
  //       ifrm.setAttribute(
  //         "src",
  //         "https://www.googletagmanager.com/ns.html?id=GTM-P64PZVB"
  //       );
  //       ifrm.style.width = "0";
  //       ifrm.style.height = "0";
  //       ifrm.style.display = "none";
  //       ifrm.style.visibility = "hidden";
  //       noscript.appendChild(ifrm);
  //       (document.body as any).prepend(noscript);
  //       const navEndEvent$ = this.router.events.pipe(
  //           filter(e => e instanceof NavigationEnd)
  //         );
  //         navEndEvent$.subscribe((e: any) => {
  //           gtag('event', 'page_view', {
  //               page_path: e.urlAfterRedirects,
  //               page_location: document.location.href
  //             })
  //         });
  //       }
  // }

}
